import React, { Component } from 'react';
import ReportHeader from '../../ReportHeader'
import ReportHeader2 from '../../ReportHeader2'
import ReportHeader3 from '../../ReportHeader3'
import ScatterPlot from 'components/custom/Highcharts/ScatterPlot'
import Section from '../../ReportSection'
import _ from 'lodash'
import {
  Table,
    TableHead,
    TableRow,
    TableCell
} from 'react-toolbox'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import ErrorTable from '../ErrorTable'
import T from 'i18n-react'
import SpecTable from 'components/display/SpecTable'
import SuccessStatus from '../../SuccessStatus/index'
import { connect } from 'react-redux'
import { downloadFiles } from 'containers/Project/NvqualSection/actions'
import { compose } from 'recompose';

const mapDispatchToProps = (dispatch) => {
  return {
      onDownloadFile: (files, name) => dispatch(downloadFiles(files, name))
  }
}

class PexDataEyeTest extends Component {

  renderTGPChart (test) {
    const cat = test.hasX ? null : test.chartCategory
    const options = {
      chart: {
        height: 550
      },
      legend: {
        maxHeight: 75
      }
    }
    return <ScatterPlot title={'Pex Data Eye Test Result'} 
      categories={cat}
      data={test.gpuInfo}
      additionalOptions={options}/>
  }


  renderAdditionalErrorInformation (errorType, info) {
    if (errorType == 'gpu_temp_exceed' || errorType == 'mem_temp_exceed') {
        return (
          TEMP_ERROR.map(x => {
                return (
                  <code>{`${T.translate(`containers.project.nvqualSection.errors.thermalBenchmarkError.${x}`)}: ${info[x]}`}<br /></code>
                )
            })
        )
    }
}


 render(){
    const { error, data, onDownloadFile, files, testName, testId, result } = this.props
    const hasErrorData = error && error.length > 0
    const test = _.get(this.props, 'data[0]', null)
  
  return(
    <Section>
      <ReportHeader title={T.translate(`containers.project.nvqualSection.test.${testId}`)}
            showDownload
            onDownloadClick={onDownloadFile.bind(this, files.map((f) => f.id), testName)}/>
      <Section>
      <ReportHeader2 title={'Summary'} />
      <SuccessStatus result={result} />
      {hasErrorData && 
        <React.Fragment>
        <ReportHeader3 title={'Errors'} />
          <ErrorTable
              errors={error}
              errorSpecificRenderFunc={this.renderAdditionalErrorInformation} />
        </React.Fragment>}
      </Section>
      <Section>
        <ReportHeader2 title={'Graph'} />
        <Section>
        {this.renderTGPChart(test)}
        </Section>
      </Section>
    </Section>
  );
 }
}

const withConnect = connect(null, mapDispatchToProps)
const withStyles = CSSModules(styles);
const enhance = compose(withConnect, withStyles);
export default enhance(PexDataEyeTest);